<button *ngIf="visible"
    class="btn-audio btn-right" 
    (click)="forward()"
    [class.disabled]="disabled === true">
    <fa-icon [icon]="faArrowRight"></fa-icon>
</button> 